var map = {
	"./aap_logo.png": 118,
	"./bg-tangerine.jpg": 4044,
	"./blue-laptop.png": 2389,
	"./buddy_love_logo.png": 6317,
	"./cf_computer.png": 1306,
	"./cj_logo.png": 9781,
	"./computer_1.jpeg": 5934,
	"./hand.svg": 3735,
	"./help.svg": 7785,
	"./logo_mark_svg.svg": 2402,
	"./logos.png": 5996,
	"./mark_white.png": 8285,
	"./mark_white.svg": 6450,
	"./ml_logo.png": 8210,
	"./ml_logo.svg": 2829,
	"./ml_logo_filled.svg": 7770,
	"./orders.png": 1303,
	"./pepper_jam.png": 9127,
	"./person_1.png": 789,
	"./person_2.jpeg": 6678,
	"./rakuten_logo.png": 5388,
	"./refund.svg": 1897,
	"./share_a_sale.png": 5673,
	"./shopify-logo.png": 6145,
	"./sitting_person.svg": 1883,
	"./step_1.png": 3986,
	"./step_2.png": 5590,
	"./step_3.png": 9687,
	"./step_4.png": 752
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4477;